import type { TrackingAttribute } from './types';

//TODO: this is copy from the wordpress project, will need to refactor later to work with this project

export function convertObjectToArray(obj: Record<string, string | number | undefined>): TrackingAttribute[] {
  return Object.entries(obj).map(([key, value]) => ({
    key: key.replace(/([A-Z])/g, '_$1').toLowerCase(),
    value,
  }));
}

export function getAdditionalTrackingProperties(): Record<string, string | undefined> {
  if (typeof document === 'undefined') return {};

  return {
    fbc: getCookieValue('_fbc'),
    fbp: getCookieValue('_fbp'),
  };
}

export function getCookieValue(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }
  return undefined;
}
